export enum SubmitType {
  SAVE = 0,
  SUBMIT = 1
}
